export const helpCenterTour = {
    module: 'help_center',
    title: 'Help Center Tour',
    title_vi: 'Tour Trung tâm hỗ trợ',
    description: 'For all personas -- DPOs, auditors, IT leads, and compliance managers -- find answers, how-to guides, and module-specific documentation to support your daily compliance workflows.',
    description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: For all personas -- DPOs, auditors, IT leads, and compliance managers -- find answers, how-to guides, and module-specific documentation to support your daily compliance workflows.',
    estimated_duration_seconds: 35,
    steps: [
        {
            step_id: 'hc_browser',
            navigate_to: '/admin/help',
            target: '.dm-page',
            wait_for: '.dm-page',
            title: 'Help Center',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Help Center',
            description: 'Your central knowledge base for compliance workflows. Whether you are a DPO handling erasure requests or an auditor assembling evidence packs, find step-by-step guidance here.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Your central knowledge base for compliance workflows. Whether you are a DPO handling erasure requests or an auditor assembling evidence packs, find step-by-step guidance here.',
            position: 'bottom',
        },
        {
            step_id: 'hc_quick_links',
            target: 'nav[aria-label="Quick links to help categories"]',
            title: 'Quick Links',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Quick Links',
            description: 'Jump to Getting Started (new users), User Guide (daily workflows), Admin Guide (platform configuration), or FAQ (common compliance questions).',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Jump to Getting Started (new users), User Guide (daily workflows), Admin Guide (platform configuration), or FAQ (common compliance questions).',
            position: 'bottom',
        },
        {
            step_id: 'hc_search',
            target: '[data-testid="help-search-input"]',
            title: 'Search for Help',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Search for Help',
            description: 'Search across all articles by keyword. Try searching for a specific compliance topic like "data mapping" or "breach notification" to find relevant guidance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Search across all articles by keyword. Try searching for a specific compliance topic like "data mapping" or "breach notification" to find relevant guidance.',
            position: 'bottom',
            action: { type: 'fill', target: '[data-testid="help-search-input"]', value: 'data mapping' },
        },
        {
            step_id: 'hc_search_button',
            target: '.dm-filters .btn-primary',
            title: 'Run Search',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Run Search',
            description: 'Click Search to find matching articles. Results are ranked by relevance with a count shown above the list.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Click Search to find matching articles. Results are ranked by relevance with a count shown above the list.',
            position: 'bottom',
            action: { type: 'click', target: '.dm-filters .btn-primary' },
            duration_ms: 300,
        },
        {
            step_id: 'hc_results',
            target: '.dm-table',
            title: 'Article Results',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Article Results',
            description: 'Each card shows the article title, category badge, module badge, and tags. Click any card to read the full article with step-by-step instructions for the compliance workflow.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Each card shows the article title, category badge, module badge, and tags. Click any card to read the full article with step-by-step instructions for the compliance workflow.',
            position: 'bottom',
        },
        {
            step_id: 'hc_category_filter',
            target: '[data-testid="categories-tab"]',
            title: 'Filter by Category',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by Category',
            description: 'Filter by category to find articles for your area of responsibility -- compliance operations, security policies, administration, or regulatory guidance.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by category to find articles for your area of responsibility -- compliance operations, security policies, administration, or regulatory guidance.',
            position: 'bottom',
        },
        {
            step_id: 'hc_module_filter',
            target: '[data-testid="module-help-tab"]',
            title: 'Filter by Module',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by Module',
            description: 'Select a specific module to show only relevant articles -- for example, filter to Incidents when responding to a breach, or Data Mapping when updating your processing records.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select a specific module to show only relevant articles -- for example, filter to Incidents when responding to a breach, or Data Mapping when updating your processing records.',
            position: 'bottom',
        },
        {
            step_id: 'hc_complete',
            target: '.dm-page',
            title: 'Help Center Tour Complete',
            title_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Help Center Tour Complete',
            description: 'You can now search for compliance guidance, browse quick-start resources, and filter documentation by category or module to support your daily workflows.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now search for compliance guidance, browse quick-start resources, and filter documentation by category or module to support your daily workflows.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=help-center.js.map